export enum CrudShowMode {
    deleted = 'deleted',
    undeleted = 'undeleted',
    all = 'all',
}
